export default __webpack_public_path__ + "static/media/clipboard.11d87f01.svg";